import { render, staticRenderFns } from "./LogoKlien.vue?vue&type=template&id=31c89dfa"
import script from "./LogoKlien.vue?vue&type=script&lang=js"
export * from "./LogoKlien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports